export const stopPointerEventBubble = (event) => {
  event.stopPropagation()
}

export const withStoppedPointerEventBubble = (handler) => (event) => {
  event.stopPropagation()
  handler(event)
}

export const pointerEventBubbleHandlers = {
  onPointerDown: stopPointerEventBubble,
  onMouseDown: stopPointerEventBubble,
  onClick: stopPointerEventBubble,
}
